import * as angular from 'angular';
import nvSdcModule from '../../../../../nv.sdcModule.module';
import { RegentsExamsScheduledTableCtrl } from './regents-exams-scheduled-table.controller';

export const RegentsExamsScheduledTable = {
  controller: RegentsExamsScheduledTableCtrl,
  bindings: {
    currentSchool: '<',
    studentSupports: '<',
  },
  template: require('./regents-exams-scheduled-table.html'),
};

angular.module(nvSdcModule).component('regentsExamsScheduledTable', RegentsExamsScheduledTable);
